// === Encryption Layout Constants ===

// Size (in bytes) of the ciphertext authentication tag (Poly1305)
export const NACL_TAG_LENGTH = 16

// Size (in bytes) of the nonce for ChaCha20-Poly1305 (must be unique per message)
export const NONCE_LENGTH = 24

// Size (in bytes) of Curve25519 keys used for ECDH and NaCl sealing
export const KEY_LENGTH = 32

// Size (in bytes) of a long-term Curve25519 public view key (identity key)
export const PUBLIC_VIEW_KEY_LENGTH = 32

// Size (in bytes) of a Kyber public key (used in hybrid post-quantum encryption)
export const KYBER_VIEW_PUBLIC_KEY_LENGTH = 2048

// Maximum size (in bytes) of the full encrypted data frame payload
// Includes conversation metadata and encrypted message content
export const MAX_PAYLOAD_SIZE = 700